import { TUI_FIRST_DAY, TUI_LAST_DAY } from "@taiga-ui/cdk";
import {
  EKwikUIInputTimeMode,
  EKwikUIInputTimeSize
} from "./input-time.definitions";

export const DEFAULT_VALUES = {
  disabled: false,
  focus: false,
  formControlName: "form_control_input_time",
  id: "input_time",
  invalid: false,
  label: "Input Time",
  mode: EKwikUIInputTimeMode.HH_MM,
  hintContent: "",
  icon: "",
  items: [],
  placeholder: "Please enter input time",
  postfix: "",
  prefix: "",
  size: EKwikUIInputTimeSize.L
};

export const VALIDATE_KEY_VALUES = {
  disabled: true,
  focus: true,
  formControlName: true,
  hintContent: true,
  icon: true,
  id: true,
  invalid: true,
  items: true,
  label: true,
  mode: true,
  placeholder: true,
  postfix: true,
  prefix: true,
  size: true
};
